import Vue from 'vue';
import Vuex from 'vuex';

import questionOptions from '@/data/questions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    name: window.unmxName || '',
    stage: 'welcome',
    title: 'Welcome',
    menuEnabled: false,
    questions: questionOptions.map(question => ({
      ...question,
      answer: null,
      saved: false,
    })),
    savedBefore: false,
    showTutorial: false,
    quizEnded: false,
    activeQuestion: null,
    hud: null,
    backgroundImage: null,
    overlayColor: 'cherry',
    willHideTutorial: false,
  },
  getters: {
    activeQuestionIndexString({ questions, activeQuestion }) {
      if (!activeQuestion) {
        return questions.length.toString();
      }

      return (
        questions.indexOf(activeQuestion) + 1
      ).toString();
      // ).toString().padStart(questions.length.toString().length, '0');
    },
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    setStage(state, stage) {
      document.documentElement.scrollTop = 0;
      state.stage = stage;

      (window.dataLayer = window.dataLayer || []).push({
        event: 'Stage Change',
        stage: state.stage,
        activeQuestion: state.activeQuestion,
      });
    },
    setTitle(state, title) {
      state.title = title;
    },
    hideTitle(state) {
      state.title = null;
    },
    hideTutorial(state) {
      state.showTutorial = false;
      state.savedBefore = true;
    },
    setShowTutorial(state, showTutorial) {
      state.showTutorial = showTutorial;
    },
    setHud(state, { top, bottom }) {
      state.hud = {
        top,
        bottom,
      };
    },
    setWillHideTutorial(state, willHideTutorial) {
      state.willHideTutorial = willHideTutorial;
    },
    setBackgroundImage(state, backgroundImage) {
      state.backgroundImage = backgroundImage;
    },
    setOverlayColor(state, overlayColor) {
      state.overlayColor = overlayColor;
    },
    toggleMenu({
      questions,
      activeQuestion,
      stage,
      quizEnded,
      showTutorial,
    }) {
      const { commit } = this;

      if (showTutorial) {
        commit('hideTutorial');
      }

      if (stage !== 'results') {
        commit('setStage', 'results');

        return;
      }

      if (quizEnded) {
        commit('setStage', 'end');

        return;
      }

      const answeredQuestions = questions.filter(({ answer }) => answer);

      if (!answeredQuestions.length) {
        commit('setStage', 'question');

        return;
      }

      commit(
        'setStage',
        (answeredQuestions.pop().answer === activeQuestion.answer
          ? 'answer' : 'question'),
      );
    },
    startQuiz(state) {
      const { commit } = this;

      commit('hideTitle');
      commit('nextQuestion');

      state.menuEnabled = true;
    },
    nextQuestion(state) {
      const { commit } = this;
      const { questions } = state;

      if (questions.filter(({ answer }) => answer).length === questions.length) {
        commit('endQuiz');

        return;
      }

      state.activeQuestion = questions.find(({ answer }) => !answer);

      commit('setStage', 'question');
    },
    toggleActiveQuestionSaved({ activeQuestion }) {
      this.commit('toggleQuestionSaved', activeQuestion);
    },
    toggleQuestionSaved(state, question) {
      const { savedBefore, stage, questions } = state;

      if (!questions.includes(question)) {
        return;
      }

      question.saved = !question.saved;

      if (!savedBefore && stage === 'answer') {
        state.savedBefore = true;
        state.showTutorial = true;
      }

      if (!savedBefore) {
        state.savedBefore = true;
      }
    },
    endQuiz(state) {
      const { commit } = this;

      commit('setStage', 'complete');

      state.quizEnded = true;
      state.menuEnabled = false;
      state.activeQuestion = undefined;
    },
    answerQuestion(state, answer) {
      state.activeQuestion.answer = answer;

      this.commit('setStage', 'answer');
    },
    /* eslint-enable no-param-reassign */
  },
});



// WEBPACK FOOTER //
// ./src/store.js